import Vue from "vue";
import Router from "vue-router";

const Main = () => import("@/components/pc/main");
const Index = () => import("@/view/pc/index");
const Financial = () => import("@/view/pc/financial");
const EnterpriseRisk = () => import("@/view/pc/enterpriseRisk");
const Login = () => import("@/view/pc/login");
const Information = () => import("@/view/pc/information");
const PolicySystem = () => import("@/view/pc/policySystem/index");
const ProductBoot = () => import("@/view/pc/productBoot.vue");
const ServiceCenter = () => import("@/view/pc/serviceCenter");

// 工作台
const Workbench = () => import("@/view/pc/workbench/components/pc/main.vue");
const OrderCenter = () => import("@/view/pc/workbench/page/orderCenter.vue");
const MyProduct = () => import("@/view/pc/workbench/page/myProduct.vue");
const AgentHome = () => import("@/view/pc/workbench/page/agentHome.vue");
const Account = () => import("@/view/pc/workbench/page/account.vue");
const workbenchLogin = () => import("@/view/pc/workbench/login.vue");
// const Invoice = () => import('@/view/pc/workbench/page/invoice.vue') 仅隐藏
const agentAccount = () => import("@/view/pc/workbench/page/agentAccount.vue");

// 联合登录页面
const UnionLoginMain = () => import("@/view/pc/unionLogin/components/pc/main.vue");
const UnionLogin = () => import("@/view/pc/unionLogin/login.vue");
const MyOrder = () => import("@/view/pc/unionLogin/page/myOrder.vue");
const ProductList = () => import("@/view/pc/unionLogin/page/productList.vue");

const OnlyProductList = () => import("@/view/pc/onlyProductList/components/pc/main.vue");
const OnlyProductListProductList = () => import("@/view/pc/onlyProductList/page/productList.vue");

// 个人登录
const LoginPersonMain = () => import("@/view/pc/loginPerson/components/pc/main.vue");
const LoginPerson = () => import("@/view/pc/loginPerson/login.vue");
const LoginPersonMyOrder = () => import("@/view/pc/loginPerson/page/myOrder.vue");

// 中通
const ZtLoginMain = () => import("@/view/pc/zt/components/pc/main.vue");
const loginZt = () => import("@/view/pc/zt/login.vue");
const ZtPolicy = () => import("@/view/pc/zt/page/ztPolicy.vue");
const ZtPersonnel = () => import("@/view/pc/zt/page/ztPersonnel.vue");

// 川分学平险 - 学校端
const EduLoginMain = () => import("@/view/pc/edu/main.vue");
const EduLogin = () => import("@/view/pc/edu/page/login.vue");
const EduTBList = () => import("@/view/pc/edu/page/tbList.vue");

// 川分学平险 - 机构端/教育局
const EduAdminLoginMain = () => import("@/view/pc/eduAdmin/main.vue");
const EduAdminLogin = () => import("@/view/pc/eduAdmin/page/login.vue");
const EduAdminTBList = () => import("@/view/pc/eduAdmin/page/tbList.vue");

// 短剧
const ShortDramaLoginMain = () => import("@/view/pc/shortDrama/main.vue");
const ShortDramaLogin = () => import("@/view/pc/shortDrama/page/login.vue");
const ShortDramaTBList = () => import("@/view/pc/shortDrama/page/policyList.vue");
const ShortDramaCrewList = () => import("@/view/pc/shortDrama/page/crewList.vue");
const ShortDramaPolicyDetail = () => import("@/view/pc/shortDrama/page/policyDetail.vue");

//吉祥保
const auspiciousMain = () => import("@/view/pc/auspicious/main.vue");
const auspiciousLogin = () => import("@/view/pc/auspicious/page/login.vue");
const auspiciousHome = () => import("@/view/pc/auspicious/page/home.vue");

// 新就业形态用工责任保险
const SncxMain = () => import("@/view/pc/sncx/components/pc/main.vue");
const SncxLogin = () => import("@/view/pc/sncx/login.vue");
const SncxProduct = () => import("@/view/pc/sncx/page/product.vue");
const SncxApply = () => import("@/view/pc/sncx/page/apply.vue");
const SncxPolicy = () => import("@/view/pc/sncx/page/policy.vue");
const SncxEndorse = () => import("@/view/pc/sncx/page/endorse.vue");
const SncxSign = () => import("@/view/pc/sncx/page/sign.vue");


Vue.use(Router);

let router = new Router({
  routes: [
    {
      path: "",
      redirect: "/index",
      component: Main,
      children: [
        {
          path: "/index",
          name: "Index",
          component: Index,
        },
        {
          path: "/financial",
          name: "Financial",
          component: Financial,
        },
        {
          path: "/enterpriseRisk",
          name: "EnterpriseRisk",
          component: EnterpriseRisk,
        },
        {
          path: "/login",
          name: "Login",
          props: true,
          component: Login,
        },
        {
          path: "/information",
          name: "Information",
          component: Information,
        },
        {
          path: "/policySystem",
          name: "PolicySystem",
          component: PolicySystem,
        },
        {
          path: "/serviceCenter",
          name: "ServiceCenter",
          component: ServiceCenter,
        },
        {
          path: "/productBoot",
          name: "ProductBoot",
          component: ProductBoot,
        },
        // {
        //   path: '/jointLogin',
        //   name: 'JointLogin',
        //   props: true,
        //   component: JointLogin
        // }
      ],
    },
    {
      path: "/workbench/home",
      name: "Workbench",
      redirect: "/workbench/page/myProduct",
      component: Workbench,
      children: [
        {
          path: "/workbench/login",
          name: "workbenchLogin",
          props: true,
          component: workbenchLogin,
        },
        {
          path: "/workbench/page/myProduct",
          name: "MyProduct",
          component: MyProduct,
        },
        {
          path: "/workbench/page/orderCenter",
          name: "OrderCenter",
          component: OrderCenter,
        },
        {
          path: "/workbench/page/agentHome",
          name: "AgentHome",
          component: AgentHome,
        },
        {
          path: "/workbench/page/account",
          name: "Account",
          component: Account,
        },
        // 仅隐藏
        // {
        //   path: '/workbench/page/invoice',
        //   name: 'Invoice',
        //   component: Invoice
        // },
        {
          path: "/workbench/page/agentAccount",
          name: "agentAccount",
          component: agentAccount,
        },
      ],
    },
    {
      path: "/unionLogin/login",
      component: UnionLoginMain,
      children: [
        {
          path: "/unionLogin/login",
          name: "UnionLogin",
          props: true,
          component: UnionLogin,
        },
        {
          path: "/unionLogin/myOrder",
          name: "MyOrder",
          props: true,
          component: MyOrder,
        },
        {
          path: "/unionLogin/productList",
          name: "ProductList",
          props: true,
          component: ProductList,
        },
      ],
    },
    {
      path: "/loginPerson/login",
      component: LoginPersonMain,
      children: [
        {
          path: "/loginPerson/login",
          name: "login",
          props: true,
          component: LoginPerson,
        },
        {
          path: "/loginPerson/myOrder",
          name: "LoginPersonMyOrder",
          props: true,
          component: LoginPersonMyOrder,
        },
      ],
    },
    {
      path: "/onlyProductList/productList",
      component: OnlyProductList,
      children: [
        {
          path: "/onlyProductList/productList",
          name: "OnlyProductListProductList",
          props: true,
          component: OnlyProductListProductList,
        },
      ],
    },
    {
      path: "/zt/login",
      component: ZtLoginMain,
      children: [
        {
          path: "/zt/login",
          name: "loginZt",
          props: true,
          component: loginZt,
        },
        {
          path: "/zt/ztPolicy",
          name: "ZtPolicy",
          props: true,
          component: ZtPolicy,
        },
        {
          path: "/zt/ztPersonnel",
          name: "ZtPersonnel",
          props: true,
          component: ZtPersonnel,
        },
      ],
    },
    {
      path: "/edu/login",
      component: EduLoginMain,
      children: [
        {
          path: "/edu/login",
          name: "eduLogin",
          props: true,
          component: EduLogin,
        },
        {
          path: "/edu/tbList",
          name: "eduTBList",
          props: true,
          component: EduTBList,
        },
      ],
    },
    {
      path: "/eduAdmin/login",
      component: EduAdminLoginMain,
      children: [
        {
          path: "/eduAdmin/login",
          name: "eduAdminLogin",
          props: true,
          component: EduAdminLogin,
        },
        {
          path: "/eduAdmin/tbList",
          name: "eduAdminTBList",
          props: true,
          component: EduAdminTBList,
        },
      ],
    },
    {
      path: "/auspicious/login",
      component:auspiciousMain,
      children: [
        {
          path: "/auspicious/login",
          name: "auspiciousLogin",
          props: true,
          component: auspiciousLogin,
        },
        {
          path: "/auspicious/home",
          name: "auspicioushome",
          props: true,
          component: auspiciousHome,
        }
      ],
    },
    {
      path: "/sncx/login",
      component: SncxMain,
      children: [
        {
          path: "/sncx/login",
          name: "sncxlogin",
          props: true,
          component: SncxLogin,
        },
        {
          path: "/sncx/product",
          name: "sncxproduct",
          props: true,
          component: SncxProduct,
        },
        {
          path: "/sncx/apply",
          name: "sncxapply",
          props: true,
          component: SncxApply,
        },
        {
          path: "/sncx/policy",
          name: "sncxpolicy",
          props: true,
          component: SncxPolicy,
        },
        {
          path: "/sncx/endorse",
          name: "sncxendorse",
          props: true,
          component: SncxEndorse,
        },
        {
          path: "/sncx/sign",
          name: "sncxsigned",
          props: true,
          component: SncxSign,
        },
      ],
    },
    {
      path: "/shortDrama/login",
      component: ShortDramaLoginMain,
      children: [
        {
          path: "/shortDrama/login",
          name: "shortDramaLogin",
          props: true,
          component: ShortDramaLogin,
        },
        {
          path: "/shortDrama/tbList",
          name: "shortDramaTBList",
          props: true,
          component: ShortDramaTBList,
        },
        {
          path: "/shortDrama/crewList",
          name: "shortDramaCrewList",
          props: true,
          component: ShortDramaCrewList,
        },
        {
          path: "/shortDrama/policyDetail",
          name: "shortDramaPolicyDetail",
          props: true,
          component: ShortDramaPolicyDetail,
        },
      ],
    },
  ],
});
router.afterEach((to, form, next) => {
  window.scrollTo(0, 0);
});

router.beforeEach((to, from, next) => {
  const agentChannel = JSON.parse(sessionStorage.getItem("agentChannel")); // 渠道
  const agent = JSON.parse(sessionStorage.getItem("agent")); // 代理人
  const routerList = [
    { path: "/workbench/page/myProduct" },
    { path: "/workbench/page/orderCenter" },
    { path: "/workbench/page/account" },
    // { path: '/workbench/page/invoice' },仅隐藏
    { path: "/workbench/page/agentAccount" },
  ];

  // 短剧险登录校验：非登录页需要检查登录状态
  if (to.path.startsWith("/shortDrama/") && to.path !== "/shortDrama/login") {
    if (!agentChannel) {
      return next("/shortDrama/login");
    }
  }

  // 跳转登录页面前保存当前地址
  if (to.path === "/login") {
    sessionStorage.setItem("beforeLoginUrl", from.fullPath);
  }
  if (routerList.some(item => item.path === to.path)) {
    if (agentChannel || agent) {
      return next();
    }
    next("/workbench/login");
  }
  //路由发生变化修改页面title
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  next();
});
export default router;



// WEBPACK FOOTER //
// ./src/router/pc/index.js